let spashSpinner = null;

// This should be called on app load
const initSpinner = () => {
  // create a fullscreen backdrop that is transparent white
  // and is absolaute positioned
  const backdrop = document.createElement("div");
  backdrop.style.position = "fixed";
  backdrop.style.top = 0;
  backdrop.style.bottom = 0;
  backdrop.style.left = 0;
  backdrop.style.right = 0;
  backdrop.style.backgroundColor = "rgba(255,255,255,0.6)";
  backdrop.style.zIndex = "10001";
  backdrop.style.textAlign = "center";
  backdrop.style.display = "flex";
  backdrop.style.alignItems = "center";
  backdrop.style.justifyContent = "center";
  backdrop.style.flexDirection = "column";
  backdrop.style.width = "100%";
  backdrop.style.height = "100%";
  backdrop.style.display = "none";

  // create a spinner element that will play a gif in the center of the screen
  const spinner = document.createElement("img");
  spinner.src =
    "https://itpcareerexpo.com/wp-content/uploads/2022/10/splashspinner.gif";
  spinner.style.width = "200px";
  spinner.style.height = "200px";
  spinner.style.margin = "auto";

  backdrop.appendChild(spinner);

  // add to body
  document.body.appendChild(backdrop);

  spashSpinner = backdrop;
};

const showSpinner = () => {
  if (!spashSpinner) {
    initSpinner();
  }

  spashSpinner.style.display = "flex";
};

const hideSpinner = () => {
  if (spashSpinner) {
    spashSpinner.style.display = "none";
  }
};

export { showSpinner, hideSpinner, initSpinner };
